<script setup lang="ts">
import Img360Page from './views/Img360Page.vue'
</script>

<template>
  <Img360Page />
</template>
